import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericWriteTableComponent } from './generic-write-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InventoryLocationsDropdownModule } from '../inventory-locations-dropdown/inventory-locations-dropdown.module';
import { InputModule } from '../input/input.module';
import { ButtonModule } from '../button/button.module';
import { AddNoteModule } from 'src/app/dashboard/components/add-note/add-note.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { YesNoToggleModule } from '../yes-no-toggle/yes-no-toggle.module';
import { BackCountNotResolvedTooltipModule } from '../back-count-not-resolved-tooltip/back-count-not-resolved-tooltip.module';



@NgModule({
  declarations: [GenericWriteTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InventoryLocationsDropdownModule,
    InputModule,
    ButtonModule,
    AddNoteModule,
    ScrollingModule,
    YesNoToggleModule,
    BackCountNotResolvedTooltipModule
  ],
  exports: [GenericWriteTableComponent]
})
export class GenericWriteTableModule { }
